export default __webpack_public_path__ + "static/1_29-6ceea456a46a2b5b822864a8c96e50fc.png";